// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expense-main-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 80vw;
  height: 100vh;
  background-color: #fff;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1300;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

/* ── Dark mode ── */
.dark .expense-main-container {
  background-color: #1e293b;
  box-shadow: -4px 0 20px rgba(0,0,0,0.4);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/ExpenseDrawer/ExpenseDrawer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,uCAAuC;AACzC","sourcesContent":[".expense-main-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 80vw;\n  height: 100vh;\n  background-color: #fff;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 1300;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease-out;\n}\n\n/* ── Dark mode ── */\n.dark .expense-main-container {\n  background-color: #1e293b;\n  box-shadow: -4px 0 20px rgba(0,0,0,0.4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
